import React from "react";
import { Accordion, Button, ListGroup, Stack } from "react-bootstrap";
import { Link } from "react-router-dom";

const AdminResultsInstructionsAccordion = ({
	onUpdateBrandTeams,
	onUpdateLeaderboards,
	resultsLinkLabel = "Go to Results Manager",
}) => {
	return (
		<Accordion defaultActiveKey="0" className="admin-instructions-accordion">
			<Accordion.Item eventKey="0">
				<Accordion.Header>Result Entry Steps</Accordion.Header>
				<Accordion.Body>
					<ListGroup as="ul" className="admin-instructions-list">
						<ListGroup.Item as="li" className="admin-instructions-item">
							Add all results. You only need to add points.
						</ListGroup.Item>
						<ListGroup.Item as="li" className="admin-instructions-item">
							Click Add rank to &quot;X&quot; data to add a rank. Make sure you
							add for qualifying and finals if they apply.
						</ListGroup.Item>
						<ListGroup.Item as="li" className="admin-instructions-item">
							Save the updates.
						</ListGroup.Item>
						<ListGroup.Item as="li" className="admin-instructions-item">
							Confirm you selected the correct series, sport, season, and event.
						</ListGroup.Item>
					</ListGroup>
					<Stack direction="horizontal" gap={2} className="mt-3 flex-wrap">
						<Button
							as={Link}
							to="/admin/results"
							variant="outline-light"
							size="sm"
						>
							{resultsLinkLabel}
						</Button>
					</Stack>
				</Accordion.Body>
			</Accordion.Item>
			<Accordion.Item eventKey="1">
				<Accordion.Header>Update Brand Teams</Accordion.Header>
				<Accordion.Body>
					<ListGroup as="ul" className="admin-instructions-list">
						<ListGroup.Item as="li" className="admin-instructions-item">
							Update brand teams on team results if brand teams apply.
						</ListGroup.Item>
					</ListGroup>
					<Stack direction="horizontal" gap={2} className="mt-3 flex-wrap">
						<Button
							variant="primary"
							size="sm"
							onClick={onUpdateBrandTeams}
							disabled={!onUpdateBrandTeams}
						>
							Update Brand Teams
						</Button>
					</Stack>
				</Accordion.Body>
			</Accordion.Item>
			<Accordion.Item eventKey="2">
				<Accordion.Header>Update Leaderboards</Accordion.Header>
				<Accordion.Body>
					<ListGroup as="ul" className="admin-instructions-list">
						<ListGroup.Item as="li" className="admin-instructions-item">
							After results and brand teams, update all leaderboards.
						</ListGroup.Item>
					</ListGroup>
					<Stack direction="horizontal" gap={2} className="mt-3 flex-wrap">
						<Button
							variant="success"
							size="sm"
							onClick={onUpdateLeaderboards}
							disabled={!onUpdateLeaderboards}
						>
							Update Leaderboards
						</Button>
					</Stack>
				</Accordion.Body>
			</Accordion.Item>
		</Accordion>
	);
};

export default AdminResultsInstructionsAccordion;
